<template>
    <div>
        <v-row class="bradcrumb">
            <router-link :to="{name: 'role-links' }" class="root">
                Dashboard
            </router-link>
            <span class="child">/ Copy Question Bank</span>
        </v-row>
        <br />
        <v-app id="inspire" class>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <center class="heading">
                <h3>Copy Question Bank</h3>
            </center>
            <div class="box">
                <v-form ref="form">
                    <v-row class="center">
                        <v-col xs="12" sm="12" lg="4" md="6" cols="12">
                            <label class="bold">Source Course</label>
                            <v-autocomplete
                                :items="crs_list"
                                item-value="course_id"
                                @change="getunit()"
                                item-text="course_name"
                                v-model="courseSrc"
                                :rules="[v => !!v || 'required']"
                                outlined
                                dense
                                placeholder="Select Exam"
                                class="select"
                            ></v-autocomplete>
                        </v-col>
                        <v-col xs="12" sm="12" lg="4" md="6" cols="12">
                            <label class="bold">Destination Course</label>
                            <v-autocomplete
                                :items="crs_list"
                                item-value="course_id"
                                @change="getunitDes()"
                                item-text="course_name"
                                v-model="courseDes"
                                :rules="[v => !!v || 'required']"
                                outlined
                                dense
                                placeholder="Select Exam"
                                class="select"
                            ></v-autocomplete>
                        </v-col>
                    </v-row>
                    <div class="unit" v-if="unitBlock">
                        <div>
                            <v-row><span style="padding-left: 10rem;">Unit No</span><span>(Question Count)</span></v-row>
                        </div>
                        <v-row>
                            <v-col>
                                <div v-for="(item,index) in question_info" :key="index">
                                    <v-row>
                                        <v-checkbox class="check" v-model="selected" :value="item.unit_no" :rules="[v => !!v || 'required']"></v-checkbox>
                                        <span>{{item.unit_no}} </span><span>({{item.qcount}})</span>
                                    </v-row>
                                </div>
                            </v-col>
                            <v-col>
                                <div v-for="(item,index) in question_info_des" :key="index" style="padding-bottom: 1.5rem;">
                                    <v-row>
                                        {{item.unit_no}}({{item.qcount}})
                                    </v-row>
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                </v-form>
                <div></div>
                <v-card-actions class="justify-center">
                    <v-btn class="mb-2 button btn" @click="copybank()" :loading="loading">Copy Question bank</v-btn>
                </v-card-actions>
            </div>
        </v-app>
    </div>
</template>

<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import datetime from "vuejs-datetimepicker";

    export default {
        components: { datetime },
        data: () => ({
            selected: [],
            checked: [],
            courseSrc: "",
            unitBlock: false,
            question_info: null,
            question_info_des: null,
            courseDes: "",
            snackbar_msg: "",
            snackbar: false,
            color: "",
            crs_list: [],
            loading: false,
            units: [
                { unit_id: 1, unit_name: "unit one" },
                { unit_id: 2, unit_name: "unit two" },
                { unit_id: 3, unit_name: "unit three" },
                { unit_id: 4, unit_name: "unit four" },
            ],
        }),

        mounted() {
            this.onLoad();
        },

        methods: {
            onLoad() {
                axios
                    .post("/CopyQuestion/getCourse")
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.crs_list = res.data.course_list;
                        } else {
                        }
                    })
                    .catch((error) => {});
            },

            copybank() {
                this.loading = true;
                const data = {
                    courseSrc: this.courseSrc,
                    courseDes: this.courseDes,
                    unitArr: this.selected,
                };
                if (this.courseSrc == this.courseDes && this.courseSrc !== undefined && this.courseDes !== undefined) {
                    this.showSnackbar("#b71c1c", "Please select different courses!!");
                    this.$refs.form.reset();
                    this.loading = false;
                    this.unitBlock = false;
                } else {
                    if (this.selected.length !== 0) {
                        if (this.courseSrc && this.courseDes) {
                            axios
                                .post("/CopyQuestion/copyquestion", data)
                                .then((res) => {
                                    if (res.data.flag == "YES") {
                                        this.showSnackbar("green", res.data.msg);
                                        this.$refs.form.reset();
                                        this.loading = false;
                                    } else {
                                    }
                                    this.unitBlock = false;
                                })
                                .catch((error) => {})
                                .finally(() => {
                                    this.loading = false;
                                });
                        } else {
                            this.showSnackbar("#b71c1c", "Please select course!!");
                            this.$refs.form.validate();
                            this.loading = false;
                        }
                    } else {
                        this.loading = false;
                        this.showSnackbar("#b71c1c", "Please select Unit!!");
                    }
                }
            },

            getunit() {
                this.unitBlock = true;
                const data = {
                    courseSrc: this.courseSrc,
                };
                axios
                    .post("/CopyQuestion/questioninfo", data)
                    .then((res) => {
                        window.console.log(res);
                        if (res.data.msg == "200") {
                            this.question_info = res.data.qinfo_list;
                        } else {
                            this.message = res.data.msg;
                        }
                    })
                    .catch((error) => {
                        window.console.log("error:" + error);
                    })
                    .finally(() => (this.fetch_org_load = false));
            },

            getunitDes() {
                this.unitBlock = true;
                const data = {
                    courseSrc: this.courseDes,
                };
                axios
                    .post("/CopyQuestion/questioninfo", data)
                    .then((res) => {
                        window.console.log(res);
                        if (res.data.msg == "200") {
                            this.question_info_des = res.data.qinfo_list;
                        } else {
                            this.message = res.data.msg;
                        }
                    })
                    .catch((error) => {
                        window.console.log("error:" + error);
                    })
                    .finally(() => (this.fetch_org_load = false));
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
    };
</script>

<style scoped>
    .unit {
        padding-left: 10rem;
    }
    .check {
        margin: 0px;
        padding: 0px 0px 0px 20px;
    }
    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }

    .v-icon-size {
        font-size: 20px;
    }

    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }

    .edit-avatar:hover {
        background-color: #b0bec5;
    }

    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }

    .edit-v-icon:hover {
        color: white;
    }
    .select >>> .v-input__slot {
        background: white !important;
        border-color: hsla(190, 99%, 30%, 1) !important;
    }
    .downbtn {
        float: right;
    }
    .box {
        background-color: #add8e630;
        margin: 8px;
        padding: 8px;
    }
    .center {
        justify-content: center;
    }
</style>
